import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SegmentsList = lazy(() => import("@segments/SegmentsList/SegmentsListForNro"));

export const segmenterNRO: NavigationRoutingObject = {
  section: "audience",
  Component: SegmentsList,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("segments-sidebar-pill-menu-option", "Segments"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("segments-description-nav", "Split your audience into segments to target a specific list of users"),
  icon: "nav-system-segments",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    { keywords: [t("segments-alt-keyword-1", "Segment API Identifier")] },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/segmenter/segmenter/:appGroupId",
};
